import React from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import R, { eqProps, equals, propOr, propEq } from 'ramda';
import BeddingConfigDumb from '../../../profile/profile-left-bar/bedding-configuration-dumb';

const displayArray = array => array.length > 1 ? Math.max(...array.map(str => parseInt(str, 10))) : array[0];

const ExportRoomPoliciesPreview = ({ policies, isAccommodation, bedsAndSofas }) => {
  if (!isAccommodation) return <div/>;
  const { tourplan, tc } = policies;
  const ifMatch = (roomType, type) => {
    if (type === 'Avail') return R.eqProps(`${roomType}Avail`, tourplan, tc);
    // return R.eqProps(`${roomType}Avail`, tourplan, tc) && R.call(R.compose(R.isEmpty, R.path(['tc', `${roomType}${type}`])), policies);
    if (tourplan[`${roomType}Avail`] === 'N' && tc[`${roomType}Avail`] === 'N') return true;
    return R.eqProps(`${roomType}Avail`, tourplan, tc) && parseInt(tc[`${roomType}${type}`], 10) === parseInt(tourplan[`${roomType}${type}`], 10);
  };
  const getColor = R.ifElse(
    ifMatch,
      R.always('rgba(0, 0, 0, 0.77)'),
    R.always('#ff4081')
  );
  const styles = StyleSheet.create({
    rowContainer: { display: 'flex', width: '100%' },
    title: { marginBottom: '16px', fontWeight: 'bold', borderBottom: '1px solid rgba(0, 0, 0, 0.34)', textAlign: 'center' },
    cell: { width: '20%', textAlign: 'center' },
    tc: { justifyContent: 'space-between', width: '95%', display: 'flex' },
  });
  return (
    <div>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%' }}/>
        <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%' }}>Room Policies</div>
      </div>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%' }}/>
        <div style={{ width: '39%' }} className={css(styles.title)}>Tourplan</div>
        <div style={{ width: '40%', marginLeft: '1%' }} className={css(styles.title)}>TourConnect</div>
      </div>
      <div className={css(styles.rowContainer)} style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
        <div style={{ width: '20%' }}/>
        <div className={css(styles.cell)} >Max Ad</div>
        <div className={css(styles.cell)} >Ad+Ch</div>
        <div className={css(styles.cell)} >Max Ad</div>
        <div className={css(styles.cell)} >Ad+Ch</div>
      </div>
      {
        [{ name: 'single', label: 'Single' }, { name: 'twin', label: 'Twin' }, { name: 'double', label: 'Double' }, { name: 'triple', label: 'Triple' }, { name: 'quad', label: 'Quad' }].map((type, index) => (
          <div className={css(styles.rowContainer)} key={index}>
            <div style={{ width: '20%', fontWeight: 'bold' }}>{type.label}</div>
            <div className={css(styles.cell)} style={{ color: getColor(type.name, 'AdMax') }}>{tourplan[`${type.name}Avail`] === 'N' ? 'NA' : tourplan[`${type.name}AdMax`]}</div>
            <div className={css(styles.cell)} style={{ color: getColor(type.name, 'Max') }}>{tourplan[`${type.name}Avail`] === 'N' ? 'NA' : tourplan[`${type.name}Max`]}</div>
            <div className={css(styles.cell)} style={{ color: getColor(type.name, 'AdMax') }}>
              {tc[`${type.name}Avail`] === 'N' ? 'NA' : ''}{tc[`${type.name}Avail`] !== 'N' && ifMatch(type.name, 'AdMax') ? tourplan[`${type.name}AdMax`] : (tc[`${type.name}AdMax`] || '')}
            </div>
            <div className={css(styles.cell)} style={{ color: getColor(type.name, 'Max') }}>
              {tc[`${type.name}Avail`] === 'N' ? 'NA' : ''}{tc[`${type.name}Avail`] !== 'N' && ifMatch(type.name, 'Max') ? tourplan[`${type.name}Max`] : (tc[`${type.name}Max`] || '')}
            </div>
          </div>
        ))
      }
      <br/>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%' }}/>
        <div style={{ width: '80%' }} className={css(styles.title)}>Bedding Configuration</div>
      </div>
      <div className={css(styles.rowContainer)}>
        <div style={{ width: '20%' }}/>
        <BeddingConfigDumb bedsAndSofas={bedsAndSofas} style={{ width: '80%' }} />
      </div>
    </div>);
};

const mapStateToProps = ({ integration }) => ({
  contractId: integration.getIn(['contract', 'contractId']),
});

export default connect(mapStateToProps)(ExportRoomPoliciesPreview);



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-room-policies.jsx